import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';

@Component({
	selector: 'app-trainer-preferences',
	templateUrl: './preferences.component.html',
	styleUrls: ['./preferences.component.css']
})
export class TrainerPreferencesComponent implements OnInit, OnChanges{
	sectors: any[];
	@Input() firstTimePreferenceLoad: boolean;
	@Output() firstTimePreferenceLoadChange = new EventEmitter();

	subSectors: { subSectors: any[] }[] = [{ subSectors: [] }];
	subDistricts: { 'code': number; 'name': string; }[];
	districts: any[];
	states: any;
	jobrole: any;
	jobRoles: { jobRoles: any[] }[] = [{ jobRoles: [] }];
	subSectorInit = false;
	loggedInUser: any;
	currentUserInfo: any;
	firstTimeLoading = true;
	previous: boolean;
	constructor(
		private sectorsService: SectorsService,
		private currentUserService: CurrentUserService,
		private fb: FormBuilder
	) { }
	@Input() group: FormGroup;

	ngOnChanges(changes: SimpleChanges){
		if (changes.group.currentValue){
			console.log(this.group.value, 'onchangecoursePreferences');
			if (this.group.value.preferences.coursePreferences.length === 0){
				this._getCurrentUser();
			}
		}
	}

	ngOnInit() {

		this.loggedInUser = this.currentUserService.decodeToken();
		this.getSectors();
		// if (this.firstTimePreferenceLoad && (this.currentUserInfo == undefined || this.currentUserInfo.coursePreferences.length === 0)) {
		// 	this.createCoursePreferencesForm();
		// }

		this.firstTimePreferenceLoad = false;
		this.firstTimePreferenceLoadChange.emit(this.firstTimePreferenceLoad);

	}

	_getCurrentUser() {
		this.currentUserService.getAdditionalInfomartion().subscribe(loggedInUser => {
			this.currentUserInfo = loggedInUser;
			if (this.coursePreferences.length === 0 && (this.currentUserInfo.coursePreferences.length === 0 || this.currentUserInfo.coursePreferences === undefined)) {
				this.createCoursePreferencesForm();
			}
			// if (this.coursePreferences.value.length == 0 && this.firstTimePreferenceLoad) {
			if (this.currentUserInfo.coursePreferences && this.currentUserInfo.coursePreferences.length > 0) {
				for (let k = 0 ; k < this.coursePreferences.value.length ; k++) {
					this.coursePreferences.value[k] = null;
				}
				for (let i = 0; i < this.currentUserInfo.coursePreferences.length; i++) {

					this.createCoursePreferencesForm(this.currentUserInfo.coursePreferences[i]);
				}
				if (this.firstTimePreferenceLoad) {
					this.group.get('heardFrom').patchValue(this.currentUserInfo.heardFrom);
				}
			}
			this.getSectors();
		});
		console.log(this.group.value);
	}

	getSectors() {
		this.sectorsService.getSectors().subscribe(sector => {
			if (sector) {
				this.sectors = sector;
				for (let i = 0; i < this.group.value.preferences.coursePreferences.length; i++) {
					console.log('Inside For LOOp', this.group.value.preferences.coursePreferences[i].sector);
					if (this.group.value.preferences.coursePreferences[i].sector !== '') {
						console.log('Inside IF');
						this.group.get('preferences').get('coursePreferences')['controls'][i].get('sectorObj').setValue(
							{
								'sector': this.group.get('preferences').get('coursePreferences')['controls'][i].get('sector').value,
								'sectorID': this.group.get('preferences').get('coursePreferences')['controls'][i].get('sectorID').value
							});
					}
					this.getSubSectors(this.group.value.preferences.coursePreferences[i].sectorObj, i, true);
				}
			}
		}, error => {
			console.log(`There was an error fetching current user details = ${error}`);
		});
		console.log(this.group.value, 'onchangecoursePreferences');


		// for(let j = 0; j < this.group.value.preferences.coursePreferences.length; j++){
		// 	this.createCoursePreferencesForm(this.group.value.preferences.coursePreferences[j]);
		// }
	}

	deleteCoursePreference(index, event) {
		// event.preventDefault();
		console.log(this.coursePreferences);
		const data = this.group.get('preferences').get('coursePreferences') as FormArray;
		// data.controls.splice(index,1);
		// data.value.splice(index,1);
		this.jobRoles.splice(index, 1);
		this.subSectors.splice(index, 1);
		this.coursePreferences.removeAt(index);
		console.log(this.group.get('preferences').get('coursePreferences'));
	}


	get coursePreferences(): FormArray {
		return this.group.get('preferences').get('coursePreferences') as FormArray;
	}

	createCoursePreferencesForm(value?: any) {

		console.log(value);
		this.coursePreferences.push(this.fb.group({
			sector: [value ? value.sector : ''],
			subSector: [value ? value.subSector : ''],
			sectorID: [value ? value.sectorId : ''],
			subSectorID: [value ? value.subSectorId : ''],
			sectorObj: ['', [Validators.required]],
			subSectorObj: ['', [Validators.required]],
			jobRole: [value ? value.jobRole : '', [Validators.required]],
			qpCode: [value ? value.qpCode : ''],
			createdDate: [new Date().toISOString()]
		}));
	}

	addCoursePreference(j) {
		console.log(j);
		this.subSectors[j] = { subSectors: [] };
		this.jobRoles[j] = { jobRoles: [] };
		if (this.coursePreferences.valid) {
			this.createCoursePreferencesForm();
		} else {
			alert('Error in form');
		}
	}



	getSubSectors(sector, i, autoCall) {
		console.log(sector);
		this.subSectors[i] = { subSectors: [] };
		this.jobRoles[i] = { jobRoles: [] };
			if (!autoCall) {
				console.log('before', this.group.get('preferences').get('coursePreferences').value);
			this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSectorObj').setValue('');
			this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSector').setValue('');
			this.group.get('preferences').get('coursePreferences')['controls'][i].get('jobRole').setValue('');
			console.log('after', this.group.get('preferences').get('coursePreferences').value);
			}
		// this.group.get('preferences').get('coursePreferences')['controls'][i].get('sector').setValue(sector.sector);
		// this.group.get('preferences').get('coursePreferences')['controls'][i].get('sectorID').setValue(sector.sectorID);
		console.log(this.group.get('preferences').get('coursePreferences'), 'this.group');

		if (sector.sectorID) {
				this.group.get('preferences').get('coursePreferences')['controls'][i].get('sector').setValue(sector.sector);
		this.group.get('preferences').get('coursePreferences')['controls'][i].get('sectorID').setValue(sector.sectorID);
			this.sectorsService.getSubSectors(sector.sectorID).subscribe(subSectors => {
				if (subSectors) {
					this.subSectors[i].subSectors = subSectors.subSectors;
					for (let i = 0; i < this.group.value.preferences.coursePreferences.length; i++) {
						console.log(this.group.value.preferences.coursePreferences);
						console.log(this.group.get('preferences').get('coursePreferences')['controls'][i].get('sectorObj').value);
						console.log(this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSector').value);
						this.group.get('preferences').get('coursePreferences')['controls'][i].get('sectorObj').patchValue(this.group.value.preferences.coursePreferences[i].sectorObj);

						if (this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSector').value) {
							this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSectorObj').setValue(
								{
									'subSectorName': this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSector').value,
									'subSectorID': this.group.get('preferences').get('coursePreferences')['controls'][i].get('subSectorID').value
								});
						}

						console.log(this.group.value);

					}
				this.getJobRoles(this.group.value.preferences.coursePreferences[i].sectorObj, this.group.value.preferences.coursePreferences[i].subSectorObj, i, true);


				}
			}, error => {
				console.log('Error in fetching states : ', error);
			});
		}
	}

	getJobRoles(sector, subsector, j, autoCall) {
		this.jobRoles[j] = { jobRoles: [] };
		console.log(j);
			if (!autoCall) {
			this.group.get('preferences').get('coursePreferences')['controls'][j].get('jobRole').setValue('');
			}
		console.log(subsector, 'SubSector');
		this.group.get('preferences').get('coursePreferences')['controls'][j].get('subSector').setValue(subsector.subSectorName);
		this.group.get('preferences').get('coursePreferences')['controls'][j].get('subSectorID').setValue(subsector.subSectorID);
		console.log(this.group.value);
		this.sectorsService.getJobRoles(sector.sectorID, subsector.subSectorID).subscribe((jobRoles) => {
			this.jobRoles[j].jobRoles = jobRoles.data;
		}, (error) => {
			console.log(`There was an error in getting the subSectors: ${error}`);
		});
		console.log('First Time Load', this.firstTimePreferenceLoad);
	}

	showSelected(item, formControlValue): boolean {
		// || (item.jobRole === formControlValue.jobRole)
		if (item && formControlValue) {
			return ((item.sectorID === formControlValue.sectorID));
		} else {
			return false;
		}
	}
	showSelectedd(item, formControlValue): boolean {
		// || (item.jobRole === formControlValue.jobRole)
		if (item && formControlValue) {
			return ((item.subSectorID === formControlValue.subSectorID));
		} else {
			return false;
		}
	}
	showSelecteddd(item, formControlValue): boolean {
		// || (item.jobRole === formControlValue.jobRole)
		console.log(item);
		console.log(formControlValue);
		if (item && formControlValue) {
			return ((item.jobRole === formControlValue.jobRole));
		} else {
			return false;
		}
	}
	getQpCode(event, j) {
		console.log(event);
		console.log(j);
		console.log(this.jobRoles[j].jobRoles);
		const selectedJobRoleArray = this.jobRoles[j].jobRoles.find(ele => ele.jobRole === event);
		console.log(selectedJobRoleArray);
		this.group.get('preferences').get('coursePreferences')['controls'][j].get('qpCode').setValue(selectedJobRoleArray.qpCode);
		console.log(this.group.get('preferences').value);
	}

}

